import React from 'react'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import * as DROPDOWN from 'constant/dropdown'
import EditWebpage from 'view/page/webpage-management/component/edit-webpage'
import formatArticle from 'helper/format-input-fields'
import PropTypes from 'prop-types'
import EditAuthor from 'view/component/table-columns/common-actions/edit-author'
import DeleteWebpage from './component/delete'
import PinWebpage from './component/pin'
import PublishWebpage from './component/publish'
import styles from './styles'

const Action = ({ webpage }) => (
  <span>
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item>
            <EditWebpage webpage={formatArticle(webpage)} />
          </Menu.Item>
          <Menu.Item>
            <DeleteWebpage webpage={webpage} />
          </Menu.Item>
          <Menu.Item>
            <PublishWebpage webpage={webpage} />
          </Menu.Item>
          <Menu.Item>
            <PinWebpage webpage={webpage} />
          </Menu.Item>
          <Menu.Item>
            <EditAuthor article={formatArticle(webpage)} />
          </Menu.Item>
        </Menu>
      }
      overlayStyle={{ zIndex: 1 }}
      trigger={[DROPDOWN.TRIGGER]}
    >
      <div className={styles.show_more}>
        <span>More</span>
        <DownOutlined />
      </div>
    </Dropdown>
  </span>)

Action.propTypes = {
  webpage: PropTypes.object
}

export default Action
